module.exports = __webpack_public_path__ + "img/pa.beb40ab6.svg";